import { render, staticRenderFns } from "./TestAdd.vue?vue&type=template&id=3ecf991f"
import script from "./TestAdd.vue?vue&type=script&lang=js"
export * from "./TestAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports